/* build/tpl */
import deps from './deps/condense.js';
import getCondense from './getCondense.js';
export default getCondense(deps);
